import { Node, StatusEnum, Uni } from '@vendia/management-api-types'
import Card from 'src/components/containers/card'
import { useIsEnterpriseOrgMember } from 'src/utils/hooks/use-is-org-member'

const FallingStars = () => {
  const dots = Array(50).fill(null)
  return (
    <div className='relative size-96 overflow-hidden rounded-full'>
      <style>{`
        @keyframes fall {
          0% {
            transform: translateY(-20px);
            opacity: 0;
          }
          80% {
            transform: translateY(-10px);
            opacity: 1;
          }
          100% {
            transform: translateY(280px);
            opacity: 0;
          }
        }
        .animate-fall {
          animation: fall linear infinite;
        }
      `}</style>
      {dots.map((_, index) => (
        <div
          key={index}
          className={`animate-fall absolute size-3 -translate-y-5 rounded-full ${index % 2 === 0 ? 'bg-blue-200' : 'bg-violet-300'}`}
          style={{
            left: `${Math.random() * 100}%`,
            animationDuration: `${3 + Math.random() * 25}s`,
            animationDelay: `${-Math.random() * 10}s`,
          }}
        />
      ))}
    </div>
  )
}

function DocLink({ isMcpFreeTier }: { isMcpFreeTier: boolean }) {
  const href = isMcpFreeTier
    ? 'https://docs.vendia.com/platform/vendia-mcp-server/overview/'
    : 'https://docs.vendia.com'

  return (
    <>
      {' '}
      Review the
      <a href={href} target='_blank' rel='noopener noreferrer' className='text-link font-bold no-underline'>
        {' '}
        docs{' '}
      </a>
      to learn what you can do with Vendia.
    </>
  )
}

export const UniPendingPlaceholder = ({ uni, node }: { uni?: Uni; node?: Node }) => {
  const { data: isEnterprise } = useIsEnterpriseOrgMember()
  const isMcpFreeTier = !isEnterprise
  const newUniMessage = 'Your project is currently spinning up and should be complete shortly!'

  if (!uni) {
    return null
  }
  return (
    <div className='flex items-center justify-center'>
      <div className='flex w-full justify-center'>
        <div className='max-w-2xl p-20'>
          <div className='relative mb-24 flex w-full justify-center'>
            <FallingStars />
            <img src='/images/rocket.svg' alt='Uni Illustration' className='absolute mt-16' />
          </div>
          {node ? (
            <div className='space-y-4'>
              <p className='font-bold'>
                {node.status === StatusEnum.Updating ? (
                  <>
                    Your project will be available as soon as the <strong>{node.name}</strong> workspace is finished
                    spinning up.
                  </>
                ) : (
                  <>{newUniMessage}</>
                )}
              </p>
              <p>
                <DocLink isMcpFreeTier={isMcpFreeTier} />
              </p>
            </div>
          ) : (
            <div className='space-y-4'>
              <p className='font-bold'>
                Your project is currently undergoing a schema update or a new release and should be complete shortly.{' '}
              </p>
              <p>
                <DocLink isMcpFreeTier={isMcpFreeTier} />
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
